<template>
  <QuestionPage :title="questionAnswerData.question">
    <QuestionAnswer
      :title='questionAnswerData.answers.A'
      class='lt-fyf-answer-home-basic'
      :onSelect="chooseBasic"
    />

    <QuestionAnswer
      :title='questionAnswerData.answers.B'
      class='lt-fyf-answer-home-medium'
      :onSelect="chooseMedium"
    />

    <QuestionAnswer
      :title='questionAnswerData.answers.C'
      class='lt-fyf-answer-home-top'
      :onSelect="chooseTop"
    />
  </QuestionPage>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('house')
    }
  },
  methods: {
    ...mapMutations([
      'selectHouseStatus',
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectHouseStatus(1);
      this.goToItem('house');
    },
    chooseMedium: function () {
      this.selectHouseStatus(2);
      this.goToItem('house');
    },
    chooseTop: function () {
      this.selectHouseStatus(3);
      this.goToItem('house');
    }
  },
};
</script>

<style lang='scss'>
.lt-fyf-answer-home-basic {
  background-image: url('../../assets/questions/house-minimum.jpg');
}
.lt-fyf-answer-home-medium {
  background-image: url('../../assets/questions/house-moderate.jpg');
}
.lt-fyf-answer-home-top {
  background-image: url('../../assets/questions/house-comfortable.jpg');
}
</style>